import { LoginForm, useAuth } from '@navix/auth-ui'
import type { User } from '@navix/auth-ui'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore'

export default function LoginPage() {
  const { isAuthenticated, token, login } = useAuth()
  const navigate = useNavigate()
  const setToken = useAuthStore((s) => s.setToken)

  useEffect(() => {
    if (isAuthenticated && token) {
      setToken(token)
      navigate('/', { replace: true })
    }
  }, [isAuthenticated, token, navigate, setToken])

  const handleLoginSuccess = (user: User, accessToken: string) => {
    login(user, accessToken)
    setToken(accessToken)
    navigate('/', { replace: true })
  }

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#1a1a2e',
    }}>
      <LoginForm
        apiUrl={import.meta.env.VITE_AUTH_URL}
        onSuccess={handleLoginSuccess}
      />
    </div>
  )
}
